import { render, staticRenderFns } from "./BannerGroup.vue?vue&type=template&id=412b6aea&scoped=true&"
import script from "./BannerGroup.vue?vue&type=script&lang=js&"
export * from "./BannerGroup.vue?vue&type=script&lang=js&"
import style1 from "./BannerGroup.vue?vue&type=style&index=1&id=412b6aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412b6aea",
  null
  
)

export default component.exports